module.exports = __webpack_public_path__ + "static/img/logo2.59fc7f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo2.png
// module id = 723
// module chunks = 1